import React from "react";

type Props = {
	site_domain: string;
	country_code: string;
	site_name: string;
};

const CookiesPolicies = ({ site_domain, country_code, site_name }: Props) => {
	return (
		<div className="safety">
			<h4>POLÍTICA DE DATOS DE NAVEGACIÓN O COOKIES DEL PORTAL {site_domain}</h4>
			<p>
				Por medio de la presente política se establece el uso y almacenamiento de los datos
				de navegación o Cookies los cuales son analizados a través de una aplicación que se
				ejecuta de manera automática en el portal de {site_domain}
				{country_code === "CO"
					? `, propiedad de EDITORA URBANA LTDA, identificada con NIT 800.229.663-1 y con domicilio principal en la ciudad de Bogotá, Colombia.`
					: "."}
			</p>
			<p>
				A través de las cookies, el portal recuerda información sobre la visita de los
				usuarios, lo que permite proporcionar una mejor y más segura experiencia de
				navegación en el mismo. Las cookies se asocian tanto a usuarios anónimos, es decir,
				aquellos que visitan el portal sin identificarse o registrarse, como aquellos que sí
				lo hacen a través de los formularios destinados para tal fin. Se aclara que las
				cookies no son un virus ni un programa de carácter malicioso, no dañan ni alteran la
				información contenida en el dispositivo usado para la navegación, ni tampoco pueden
				acceder a información y datos contenidos en el dispositivo.
			</p>
			<p>
				Las cookies se crean y/o actualizan en el computador o dispositivo del usuario de
				manera automática, cuando éste accede al portal {site_domain}, lo cual permite
				realizar seguimiento a los datos de navegación o cookies. Se aclara que las cookies
				sólo son leídas por el sitio web que las creó.
			</p>
			<p>
				Estas cookies son esenciales para el uso del Portal, en el sentido de facilitar el
				proceso de registro en el mismo, así como permitir a los usuarios un acceso más
				rápido y seguro a los servicios seleccionados dentro del Portal. Sin estas cookies,
				es posible que EDITORA URBANA no les pueda ofrecer a los usuarios ciertos servicios
				dentro del Portal y éste puede que no funcione con normalidad. Así mismo, mediante el
				uso de estas cookies, EDITORA URBANA podrá entregarle al usuario publicidad que
				considere que puede llegar a ser de su interés, según las preferencias y
				comportamientos que el usuario tiene o ha tenido dentro del portal web. A través de
				estas cookies, se podrá optimizar la
				publicidad que el usuario ve en el Portal. Las
				cookies de publicidad, podrán ser entregadas a anunciantes de EDITORA URBANA, para
				que sean utilizadas por éstos para sus campañas de mercadeo y publicidad.
			</p>
			<p>
				Finalmente, a través de las cookies, EDITORA URBANA o el tercero que éste contrate,
				puede realizar distintos análisis y estudios de la información recolectada, con el
				fin de mejorar los productos y servicios que se ofrecen a los usuarios. EDITORA
				URBANA y los terceros con los que contrate servicios para el uso de cookies, son los
				únicos que podrán acceder a la información almacenada en las cookies que se han
				instalado dentro del equipo del usuario. La información almacenada en las cookies no
				puede ser leída por otros usuarios, ni éstos podrán acceder a la misma.
			</p>
			<p>
				El usuario puede deshabilitar tanto la instalación de las cookies como el uso de las
				mismas por parte de EDITORA URBANA. Para deshabilitar la instalación y uso de
				cookies el usuario deberá realizar el procedimiento de acuerdo con el navegador
				usado (Chrome, Internet Explorer, Mozilla, etc.)
			</p>
			<p>
				Si el usuario deshabilita la instalación o el uso de las cookies para el portal,
				podrá perder o afectar algunas funcionalidades del sitio, como por ejemplo:
			</p>
			<ul>
				<li>
					Poder ingresar al Portal sin necesidad de indicar en cada ocasión su usuario y
					contraseña.
				</li>
				<li>Publicación de comentarios dentro del Portal.</li>
				<li>Seguridad en el uso de la información que se ingresa en el Portal.</li>
				<li>Rapidez en el uso de algún servicio dentro del Portal.</li>
			</ul>
			<p>
				EDITORA URBANA podrá compartir información obtenida a través de las cookies con
				personas externas o terceros (aliados, clientes, proveedores o empresas vinculadas a
				EDITORA URBANA), con el fin de mejorar la usabilidad y servicios al usuario. Así
				mismo, la información que se recibe a través de las cookies será utilizada por
				EDITORA URBANA y los anteriores terceros, para los fines descritos en el presente
				documento, los indicados en nuestra Política de privacidad, y cualquiera de sus
				actualizaciones.
			</p>
			<p>
				EDITORA URBANA podrá contratar terceras personas encargadas de almacenar y obtener
				la información a través de las cookies, o que incluyan cookies dentro del portal
				{site_domain}, personas que podrán estar localizadas dentro de Colombia o en
				el exterior. Así mismo, EDITORA URBANA podrá entregar a terceros, la información que
				se obtenga de las cookies para crear perfiles de usuarios, ofrecer campañas
				personalizadas, sin que lo anterior implique entrega de información personal.
			</p>
			<p>
				La información obtenida a través de estas cookies, referida al equipo del usuario,
				podrá ser combinada con sus datos personales sólo si usted está registrado en el
				portal {site_domain}.co
			</p>
			<p>
				La presente Política contiene la información necesaria que debe conocer todo usuario
				del Portal sobre el uso de las cookies que realiza EDITORA URBANA o los terceros que
				éste contrate. EDITORA URBANA podrá modificar el presente documento en cualquier
				momento y sin previo aviso para mantenerlo vigente y actualizado. Por lo anterior,
				recomendamos a los usuarios revisar la fecha de elaboración o actualización de los
				mismos, la cual se establece al final del presente documento.
			</p>
			<p>
				En caso de dudas o inquietudes acerca del uso de cookies o sobre cualquiera de los
				puntos detallados en esta Política, puede contactarnos{" "}
				{country_code === "CO"
					? `a través de nuestro servicio de call center en Bogotá al teléfono 3330333280 o a la Línea Nacional 3174359175, `
					: ""}
				a través del portal web {site_domain} o escribirnos a través del correo electrónico{" "}
				{country_code === "CO"
					? "servicio.cliente@fincaraiz.com.co"
					: `info@${site_name.toLowerCase()}.com.${country_code}`}
				.
			</p>
		</div>
	);
};

export default CookiesPolicies;
